import Vue from 'vue'
import Vuex from 'vuex'
import feathers, { FeathersVuex, BaseModel, makeServicePlugin, models } from './feathers-client'
import auth from './store.auth'

Vue.use(Vuex)
Vue.use(FeathersVuex)

/* eslint-disable no-useless-constructor */
class AppsCatalystActivity extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-activity'
}
class AppsCatalystSchedule extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-schedule'
}
class AppsCatalystQuoteDuplicate extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-quote-duplicate'
}
class AppsCatalystQuoteGenerate extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-quote-generate'
}
class AppsCatalystQuoteGenerateVm extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-quote-generate-vm'
}
class AppsCatalystIncluye extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-incluye'
}
class AppsCatalystDayPhoto extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-day-photo'
}
class AppsCatalystType extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-type'
}
class AppsCatalystCategory extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-category'
}
class AppsCatalystItem extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-item'
  // static instanceDefaults (data) {
  //   return {
  //     totalPax: 2
  //   }
  // }
}
class AppsCatalystItemAvailable extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-item-available'
}
class AppsCatalystItemAvailableSearch extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-item-available-search'
}
class AppsCatalystItemAvailablePrice extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-item-available-price'
}
class AppsCatalystContactSearch extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-contact-search'
}
class AppsCatalystContact extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-contact'
}
class ServiceRegisterUserEmail extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'service-register-user-email'
}
class AppsPmProject extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-pm-project'
}
class AppsPmTask extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-pm-task'
}
class AppsPmTaskStatus extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-pm-task-status'
}
class AppsPmTaskApproval extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-pm-task-approval'
}
class Dashboard extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'dashboard'
}
class UsersData extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'users-data'
}
class MyCompany extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'my-company'
}
class ServiceAdminUser extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'service-admin-user'
}
class MongooseImage extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'mongoose-image'
}
class MongooseAddress extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'mongoose-address'
}
class MongooseCountry extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'mongoose-country'
}
class MongooseCompany extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'mongoose-company'
}
class MongoosePlace extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'mongoose-place'
}
class SandboxPrivate extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'sandbox-private'
}
class SandboxPublic extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'sandbox-public'
}
class ServiceListCompany extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'service-list-company'
}
class ServiceSelectCompany extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'service-select-company'
}
class ServiceSendInvite extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'service-send-invite'
}
class Country extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'country'
}
class AppsCatalystDraft extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-draft'
  static instanceDefaults (data) {
    return {
      items: [],
      days: []
    }
  }

  static setupInstance (data, { models, store }) {
    // const { AppsCatalystItem, AppsCatalystDay } = models.api
    Object.assign(data, {
      ...(data.items && Array.isArray(data.items) && { items: data.items.map(d => new AppsCatalystItem(d)) }),
      ...(data.days && Array.isArray(data.days) && { days: data.days.map(d => new AppsCatalystDay(d)) })
    })
    return data
  }
}
class AppsCatalystQuote extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-quote'
  static instanceDefaults (data) {
    return {
      activities: 'AppsCatalystActivity',
      schedules: 'AppsCatalystSchedule'
    }
  }
}
class AppsCatalystDay extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-catalyst-day'
  static instanceDefaults (data) {
    return {
      schedules: []
    }
  }

  static setupInstance (data, { models, store }) {
    // const { AppsCatalystSchedule } = models.api
    if (data.schedules) {
      try {
        data.schedules = data.schedules.map(d => new AppsCatalystSchedule(d))
      } catch (e) {
        console.log('>>>> fail A3 >>>', e)
      }
    }
    return data
  }
}
class AppsLinksLink extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-links-link'
  static instanceDefaults (data) {
    return {
      tasks: 'AppsLinksLink' // 'apps-links-link'
    }
  }
}
class AppsPmTopic extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'apps-pm-topic'
  static instanceDefaults (data) {
    return {
      tasks: 'AppsPmTask' // 'apps-pm-task'
    }
  }
}
class MongooseFamily extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'mongoose-family'
  static instanceDefaults (data) {
    return {
      people: 'MongoosePerson'
    }
  }
}
class MongoosePerson extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'mongoose-person'
  static instanceDefaults (data) {
    return {
      addresses: 'MongooseAddress'
    }
  }
}
// service('users'),
class Users extends BaseModel {
  constructor (data, options) { super(data, options) }
  static modelName = 'users'
}

export default new Vuex.Store({
  state: {
    code: '',
    count: 0,
    logged: false,
    photo: false,
    customData: {},
    activeSections: {},
    displayName: '',
    accessData: {},
    totalPax: 0,
    exp: 40085888000000 // future date
  },
  mutations: {
    setCode (state, newValue) {
      state.code = newValue
    },
    setPhoto (state, newValue) {
      state.photo = newValue
    },
    setLogged (state, newValue) {
      state.logged = newValue
    },
    setDisplayName (state, newValue) {
      state.displayName = newValue
    },
    setCustomData (state, newValue) {
      state.customData = newValue
    },
    increment (state) {
      state.count++
    },
    setActiveSections (state, newValue) {
      state.activeSections = newValue
    },
    setAccessData (state, newValue) {
      state.accessData = newValue
    },
    setTotalPax (state, newValue) {
      state.totalPax = newValue
    },
    setExp (state, newValue) {
      state.exp = newValue
    }
  },
  // actions: {},
  // modules: {},
  getters: {
    getCode: (state) => {
      return state.code
    },
    getLogged: (state) => {
      return state.logged
    },
    getDisplayName: (state) => {
      return state.displayName
    },
    getCustomData: (state) => {
      return state.customData
    },
    count: state => {
      return state.count
      // return state.count.filter(todo => todo.done)
    },
    getActiveSections: (state) => {
      return state.activeSections
    },
    getAccessData: (state) => {
      return state.accessData
    },
    getTotalPax: (state) => {
      return state.totalPax
    },
    getExp: (state) => {
      return state.exp
    }
  },
  plugins: [
    makeServicePlugin({
      Model: AppsCatalystActivity,
      service: feathers.service(AppsCatalystActivity.modelName),
      servicePath: AppsCatalystActivity.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystSchedule,
      service: feathers.service(AppsCatalystSchedule.modelName),
      servicePath: AppsCatalystSchedule.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystQuoteDuplicate,
      service: feathers.service(AppsCatalystQuoteDuplicate.modelName),
      servicePath: AppsCatalystQuoteDuplicate.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystQuoteGenerate,
      service: feathers.service(AppsCatalystQuoteGenerate.modelName),
      servicePath: AppsCatalystQuoteGenerate.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystQuoteGenerateVm,
      service: feathers.service(AppsCatalystQuoteGenerateVm.modelName),
      servicePath: AppsCatalystQuoteGenerateVm.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystIncluye,
      service: feathers.service(AppsCatalystIncluye.modelName),
      servicePath: AppsCatalystIncluye.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystDayPhoto,
      service: feathers.service(AppsCatalystDayPhoto.modelName),
      servicePath: AppsCatalystDayPhoto.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystType,
      service: feathers.service(AppsCatalystType.modelName),
      servicePath: AppsCatalystType.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystCategory,
      service: feathers.service(AppsCatalystCategory.modelName),
      servicePath: AppsCatalystCategory.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystItem,
      service: feathers.service(AppsCatalystItem.modelName),
      servicePath: AppsCatalystItem.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystItemAvailable,
      service: feathers.service(AppsCatalystItemAvailable.modelName),
      servicePath: AppsCatalystItemAvailable.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystItemAvailableSearch,
      service: feathers.service(AppsCatalystItemAvailableSearch.modelName),
      servicePath: AppsCatalystItemAvailableSearch.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystItemAvailablePrice,
      service: feathers.service(AppsCatalystItemAvailablePrice.modelName),
      servicePath: AppsCatalystItemAvailablePrice.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystContactSearch,
      service: feathers.service(AppsCatalystContactSearch.modelName),
      servicePath: AppsCatalystContactSearch.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystContact,
      service: feathers.service(AppsCatalystContact.modelName),
      servicePath: AppsCatalystContact.modelName
    }),
    makeServicePlugin({
      Model: ServiceRegisterUserEmail,
      service: feathers.service(ServiceRegisterUserEmail.modelName),
      servicePath: ServiceRegisterUserEmail.modelName
    }),
    makeServicePlugin({
      Model: AppsPmProject,
      service: feathers.service(AppsPmProject.modelName),
      servicePath: AppsPmProject.modelName
    }),
    makeServicePlugin({
      Model: AppsPmTask,
      service: feathers.service(AppsPmTask.modelName),
      servicePath: AppsPmTask.modelName
    }),
    makeServicePlugin({
      Model: AppsPmTaskStatus,
      service: feathers.service(AppsPmTaskStatus.modelName),
      servicePath: AppsPmTaskStatus.modelName
    }),
    makeServicePlugin({
      Model: AppsPmTaskApproval,
      service: feathers.service(AppsPmTaskApproval.modelName),
      servicePath: AppsPmTaskApproval.modelName
    }),
    makeServicePlugin({
      Model: Dashboard,
      service: feathers.service(Dashboard.modelName),
      servicePath: Dashboard.modelName
    }),
    makeServicePlugin({
      Model: UsersData,
      service: feathers.service(UsersData.modelName),
      servicePath: UsersData.modelName
    }),
    makeServicePlugin({
      Model: MyCompany,
      service: feathers.service(MyCompany.modelName),
      servicePath: MyCompany.modelName
    }),
    makeServicePlugin({
      Model: ServiceAdminUser,
      service: feathers.service(ServiceAdminUser.modelName),
      servicePath: ServiceAdminUser.modelName
    }),
    makeServicePlugin({
      Model: MongooseImage,
      service: feathers.service(MongooseImage.modelName),
      servicePath: MongooseImage.modelName
    }),
    makeServicePlugin({
      Model: MongooseAddress,
      service: feathers.service(MongooseAddress.modelName),
      servicePath: MongooseAddress.modelName
    }),
    makeServicePlugin({
      Model: MongooseCountry,
      service: feathers.service(MongooseCountry.modelName),
      servicePath: MongooseCountry.modelName
    }),
    makeServicePlugin({
      Model: MongooseCompany,
      service: feathers.service(MongooseCompany.modelName),
      servicePath: MongooseCompany.modelName
    }),
    makeServicePlugin({
      Model: MongoosePlace,
      service: feathers.service(MongoosePlace.modelName),
      servicePath: MongoosePlace.modelName
    }),
    makeServicePlugin({
      Model: SandboxPrivate,
      service: feathers.service(SandboxPrivate.modelName),
      servicePath: SandboxPrivate.modelName
    }),
    makeServicePlugin({
      Model: SandboxPublic,
      service: feathers.service(SandboxPublic.modelName),
      servicePath: SandboxPublic.modelName
    }),
    makeServicePlugin({
      Model: ServiceListCompany,
      service: feathers.service(ServiceListCompany.modelName),
      servicePath: ServiceListCompany.modelName
    }),
    makeServicePlugin({
      Model: ServiceSelectCompany,
      service: feathers.service(ServiceSelectCompany.modelName),
      servicePath: ServiceSelectCompany.modelName
    }),
    makeServicePlugin({
      Model: ServiceSendInvite,
      service: feathers.service(ServiceSendInvite.modelName),
      servicePath: ServiceSendInvite.modelName
    }),
    makeServicePlugin({
      Model: Country,
      service: feathers.service(Country.modelName),
      servicePath: Country.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystDraft,
      service: feathers.service(AppsCatalystDraft.modelName),
      servicePath: AppsCatalystDraft.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystQuote,
      service: feathers.service(AppsCatalystQuote.modelName),
      servicePath: AppsCatalystQuote.modelName
    }),
    makeServicePlugin({
      Model: AppsCatalystDay,
      service: feathers.service(AppsCatalystDay.modelName),
      servicePath: AppsCatalystDay.modelName
    }),
    makeServicePlugin({
      Model: AppsPmTopic,
      service: feathers.service(AppsPmTopic.modelName),
      servicePath: AppsPmTopic.modelName
    }),
    makeServicePlugin({
      Model: AppsLinksLink,
      service: feathers.service(AppsLinksLink.modelName),
      servicePath: AppsLinksLink.modelName
    }),
    makeServicePlugin({
      Model: MongooseFamily,
      service: feathers.service(MongooseFamily.modelName),
      servicePath: MongooseFamily.modelName
    }),
    makeServicePlugin({
      Model: MongoosePerson,
      service: feathers.service(MongoosePerson.modelName),
      servicePath: MongoosePerson.modelName
    }),
    // Setup the auth plugin.
    // service('users', { paginate: true }),
    // service('users', { paginate: true }),
    // auth({ userService: 'users' })
    makeServicePlugin({
      Model: Users,
      service: feathers.service(Users.modelName),
      servicePath: Users.modelName
    }),
    auth

    // service('person', {
    //   instanceDefaults: {
    //     addresses: 'Address', // references the 'addresses' service
    //     newElement: 'Address',
    //     // selected: null,
    //     get calculo1 () {
    //       return 1111
    //     },
    //     algo: function () {
    //       console.log('>>> in algo')
    //       console.log(this)
    //       console.log(this.name)
    //       console.log(this.myMethod())
    //       console.log(this.addresses.length)
    //       // this.commit('addItem', '1231')
    //       // let newTodo = { description: 'write good tests' }
    //       // const todo = new Todo({ description: 'Do something!' })
    //       // this.addresses.push(todo)

    //       // console.log(this)
    //       // this.dispatch('person/create', newTodo)
    //       // this.addresses.push(feathersVuex.)
    //       // this.addresses.push(new Todo(data))
    //     },
    //     myMethod: () => { return 11111 }
    //     // zips: 'Zip' // references the `zips` service
    //     // demo4: async data => {
    //     //   console.log('>>> inside of demo4')
    //     //   console.log(data)
    //     //   console.log(this)
    //     //   let total = 0.01
    //     //   data.forEach((elem, index) => {
    //     //     try {
    //     //       console.log('>>> age:', elem.age, 'name', elem.name, 'total', data.length, 'index', index)
    //     //       total += parseInt(elem.age)
    //     //     } catch (e) {
    //     //       console.log('>>> exception:', e)
    //     //     }
    //     //   })
    //     //   console.log('>>> total', total)
    //     //   return total
    //     // }
    //   }
    // }),
    // service('address', {
    //   instanceDefaults: {
    //     myMethod: function () {
    //       console.log('will it save??', this.save()) // don't handle the result
    //     },
    //     saveWithPrompt: async function () {
    //       if (this.line1 && this.line1.length > 3) {
    //         return this.save()
    //       } else {
    //         return Promise.reject(new Error('nooooo'))
    //       }
    //     }
    //   }
    // }),
    // // Specify custom options per service
    // service('/v1/tasks', {
    //   idField: '_id', // The field in each record that will contain the id
    //   nameStyle: 'path', // Use the full service path as the Vuex module name, instead of just the last section
    //   namespace: 'custom-namespace', // Customize the Vuex module name.  Overrides nameStyle.
    //   autoRemove: true, // Automatically remove records missing from responses (only use with feathers-rest)
    //   enableEvents: false, // Turn off socket event listeners. It's true by default
    //   addOnUpsert: true, // Add new records pushed by 'updated/patched' socketio events into store, instead of discarding them. It's false by default
    //   skipRequestIfExists: true, // For get action, if the record already exists in store, skip the remote request. It's false by default
    //   modelName: 'OldTask' // Default modelName would have been 'Task'
    // }),

    // // Add custom state, getters, mutations, or actions, if needed.  See example in another section, below.
    // service('sandbox-public2', {
    //   idField: '_id',
    //   // state: {},
    //   // getters: {},
    //   // mutations: {},
    //   // actions: {},
    //   // instanceDefaults: {
    //   //   addresses: 'Address', // references the 'addresses' service
    //   //   zips: 'Zip' // references the `zips` service
    //   // }
    //   // nameStyle: 'path', // Use the full service path as the Vuex module name, instead of just the last section
    //   // namespace: 'custom-namespace', // Customize the Vuex module name.  Overrides nameStyle.
    //   autoRemove: true, // Automatically remove records missing from responses (only use with feathers-rest)
    //   enableEvents: false, // Turn off socket event listeners. It's true by default
    //   addOnUpsert: true, // Add new records pushed by 'updated/patched' socketio events into store, instead of discarding them. It's false by default
    //   skipRequestIfExists: true // For get action, if the record already exists in store, skip the remote request. It's false by default
    //   // modelName: 'OldTask' // Default modelName would have been 'Task'
    // }),

    // // Setup a service with defaults for Model instances
    // service('manufacturers', {
    //   instanceDefaults: {
    //     name: ''
    //   }
    // }),
    // // Setup a service with light-weight relational data
    // service('models', {
    //   instanceDefaults: {
    //     name: '',
    //     manufacturerId: '',
    //     manufacturer: 'Manufacturer' // Refers to data (populated on the server) that gets put in the `manufacturers` vuex store.
    //   }
    // }),
  ]
})
